import { useMemo } from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  ShoppingCart as ShoppingCartIcon,
  ShoppingBasket as ShoppingBasketIcon,
  Category as CategoryIcon,
} from '@material-ui/icons';
import { ProductType } from '../../../products/types/product-types.type';

type OrderItemType = ProductType | 'basket' | 'virtual';

type OrderItemTypeChipProps = {
  type: OrderItemType;
  size?: 'small' | 'medium';
};

const useStyles = makeStyles(() => ({
  root: (props: { backgroundColor: string; color: string }) => ({
    borderRadius: 4,
    textTransform: 'capitalize',
    backgroundColor: props.backgroundColor,
    color: props.color,

    '& .MuiChip-label': {
      display: 'flex',
      alignItems: 'center',
      gap: 6,

      '& > svg': {
        width: 16,
        height: 16,
        fill: props.color,
      },

      '& > span': {
        fontSize: 12,
        lineHeight: '14px',
      },
    },
  }),
}));

const getChipStyle = (type: OrderItemType): { backgroundColor: string; color: string; icon: React.ReactElement; label: string } => {
  switch (type) {
    case 'product':
      return { backgroundColor: '#4caf50', color: '#ffffff', icon: <ShoppingCartIcon />, label: 'Produit' };
    case 'basket':
      return { backgroundColor: '#ff9800', color: '#ffffff', icon: <ShoppingBasketIcon />, label: 'Panier' };
    case 'virtual':
      return { backgroundColor: '#9e9e9e', color: '#ffffff', icon: <CategoryIcon />, label: 'Virtuel' };
  }
};

export default function OrderItemTypeChip({ type, size = 'small' }: OrderItemTypeChipProps) {
  const { label, backgroundColor, color, icon } = useMemo(() => getChipStyle(type), [type]);

  const classes = useStyles({ backgroundColor, color });

  return (
    <Chip
      className={classes.root}
      size={size}
      label={
        <>
          {icon}
          <span>{label}</span>
        </>
      }
    />
  );
}
